import { Injectable, signal } from '@angular/core';
import { NewPrinterFormGroups, NewPrinterValidators, PrintersFieldForm } from '../models/settings-printers.model';
import { CustomFormControl, CustomFormGroup } from '@tilby/tilby-ui-lib/components/tilby-magic-form';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export const atLeastOneTrue = (fields: string[]): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control;
    
    const isAtLeastOneTrue = fields.some(fieldName => {
      const fieldControl = formGroup.get(fieldName);
      return fieldControl?.value === true;
    });

    return isAtLeastOneTrue ? null : { atLeastOneTrue: true };
  };
}
@Injectable()
export class NewPrinterFormService {

  private printerForm!: NewPrinterFormGroups;
  
  get form() {
    return this.printerForm;
  }

  printerFormReady = signal(false);

  validators: NewPrinterValidators = {
    nameMinLength: 3,
    nameMaxLength: 25,
    ipAddressMaxLength: 255,

    // --------
    provMinLength: 0,
    provMaxLength: 255,
    provMaxLengthArray: new Array(10).fill(2)
  };

  createForm() {
    this.printerFormReady.set(false);
    
    this.printerForm = new CustomFormGroup<PrintersFieldForm>({
      configuration_pending: new CustomFormControl(
        true
      ),
      type: new CustomFormControl(
        null
      ),
      manifacturer: new CustomFormControl(
        null
      ),
      name: new CustomFormControl(
        null,
        { validators: [Validators.required, Validators.minLength(this.validators.nameMinLength), Validators.maxLength(this.validators.nameMaxLength)] }
      ),
      ip_address: new CustomFormControl(
        null,
        { validators: [Validators.required, Validators.maxLength(this.validators.ipAddressMaxLength)] }
      ),
      driver: new CustomFormControl(
        null,
        { validators: [Validators.required] }
      ),
      connection_type: new CustomFormControl(
        null
      ),
      fiscal_provider: new CustomFormControl(
        null
      ),
      configuration: new CustomFormControl(
        null
      ),
      print_e_invoice: new CustomFormControl(
        false
      ),
      print_fiscal_receipt: new CustomFormControl(
        false
      ),
      print_generic_document: new CustomFormControl(
        false
      ),
      print_generic_invoice: new CustomFormControl(
        false
      ),
      print_generic_receipt: new CustomFormControl(
        false
      ),
      print_invoice: new CustomFormControl(
        false
      ),
      print_receipt: new CustomFormControl(
        false
      ),
      print_receipt_invoice: new CustomFormControl(
        false
      ),
      print_shipping_invoice: new CustomFormControl(
        false
      ),
      print_summary_e_nrc: new CustomFormControl(
        false
      ),
      print_summary_e_rc: new CustomFormControl(
        false
      ),
      print_summary_invoice: new CustomFormControl(
        false
      )
    } as PrintersFieldForm)

    this.printerFormReady.set(true);
    return this.printerForm;
  }

  get configurationPending() {
    return this.printerForm.controls.configuration_pending;
  }

  get type() {
    return this.printerForm.controls.type;
  }

  get manifacturer() {
    return this.printerForm.controls.manifacturer;
  }

  get name() {
    return this.printerForm.controls.name;
  }

  get ipAddress() {
    return this.printerForm.controls.ip_address;
  }

  get driver() {
    return this.printerForm.controls.driver;
  }

  get connectionType() {
    return this.printerForm.controls.connection_type;
  }

  get fiscalProvider() {
    return this.printerForm.controls.fiscal_provider;
  }

  get configuration() {
    return this.printerForm.controls.fiscal_provider;
  }

  get printEinvoice() {
    return this.printerForm.controls.print_e_invoice;
  }

  get printFiscalReceipt() {
    return this.printerForm.controls.print_fiscal_receipt;
  }

  get printGenericDocument() {
    return this.printerForm.controls.print_generic_document;
  }

  get printGenericInvoice() {
    return this.printerForm.controls.print_generic_invoice;
  }

  get printGenericReceipt() {
    return this.printerForm.controls.print_generic_receipt;
  }

  get printInvoice() {
    return this.printerForm.controls.print_invoice;
  }

  get printReceipt() {
    return this.printerForm.controls.print_receipt;
  }

  get printReceiptInvoice() {
    return this.printerForm.controls.print_receipt_invoice;
  }

  get printShippingInvoice() {
    return this.printerForm.controls.print_shipping_invoice;
  }

  get printSummaryEnrc() {
    return this.printerForm.controls.print_summary_e_nrc;
  }

  get printSummaryErc() {
    return this.printerForm.controls.print_summary_e_rc;
  }

  get printSummaryInvoice() {
    return this.printerForm.controls.print_summary_invoice;
  }
}